/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Grid,
  Stack,
  Button,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PaymentInfo from './PaymentInfo';
import PaymentInvoice from './PaymentInvoice';
import PaymentIframe from './PaymentIframe';

export default function PaymentDialog({
  open,
  onClose,
  iframeUrl,
  userEmail,
  userName,
  currentBalance,
  bundle,
  userAvatar,
}) {
  const [loading, setLoading] = useState(false);
  const [showIframe, setShowIframe] = useState(false);

  const handlePayNow = () => {
    setLoading(true);
    setTimeout(() => {
      setShowIframe(true);
      setLoading(false);
    }, 1500);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 4 }}>
        <Grid container spacing={3}>
          {/* الجزء الأول: معلومات المستخدم أو الفاتورة بعد الدفع */}
          <Grid item xs={12} md={6}>
            {!showIframe ? (
              <PaymentInfo
                userName={userName}
                userEmail={userEmail}
                userAvatar={userAvatar}
                currentBalance={currentBalance}
                bundle={bundle}
              />
            ) : (
              <PaymentInvoice bundle={bundle} />
            )}
          </Grid>

          {/* الجزء الثاني: الفاتورة أو الـ iframe */}
          <Grid item xs={12} md={6}>
            {!showIframe ? (
              <Stack spacing={2}>
                <PaymentInvoice bundle={bundle} />
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                  <Button variant="outlined" color="error" onClick={onClose}>
                    Close
                  </Button>
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: '#007d7d',
                        color: 'white',
                        width: 150,
                        '&:hover': {
                          bgcolor: '#006666', 
                        },
                      }}
                      onClick={handlePayNow}
                      disabled={loading}
                    >
                      {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Pay Now'}
                    </Button>

                </Stack>
              </Stack>
            ) : (
              <PaymentIframe iframeUrl={iframeUrl} />
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
